import { ApiService } from 'Features/bizgainOnboarding/services/apiService';
const { createCampaigns } = new ApiService();
import { bizgainOnboardingRoutes, SchedulingModes, DurationTypes } from 'Features/bizgainOnboarding/constants';
import moment from 'moment';
export const createSubSequentCampaign = async (businessProfileId, additionalconfiguration) => {
  const campaignTimeStampFormat = 'YYYY-MM-DD HH:mm';
  let campaign = {
    name: `Campaign ${moment().format(campaignTimeStampFormat)}`,
    budget: '1',
    budgetType: DurationTypes.LIFETIME,
    objectiveId: 1,
    startDate: moment().add(2, 'days')
      .format('YYYY-MM-DD'),
    endDate: moment().add(9, 'days')
      .format('YYYY-MM-DD'),
    schedulingMode: SchedulingModes.RunContinuously,
    additionalConfigurationJson: JSON.stringify({ ...additionalconfiguration }),
    isDraft: true
  }
  let response = await createCampaigns(businessProfileId, campaign);
  return response;
}

export const assignSubsequentFlowMeta = async (to) => {
  to.meta.stepCount = 6;
  switch (to.name) {
    /* Step No 1 */
    case bizgainOnboardingRoutes.SubsequentSelectObjective.name: to.meta.stepNumber = 1; break;

    /* Step No 2 */
    case bizgainOnboardingRoutes.SubsequentPromoteServices.name: to.meta.stepNumber = 2; break;
    case bizgainOnboardingRoutes.SubsequentExtractOfferDetails.name: to.meta.stepNumber = 2; break;

    /* Step No 3 */
    case bizgainOnboardingRoutes.SubsequentImageCreatives.name: to.meta.stepNumber = 3; break;
    case bizgainOnboardingRoutes.SubsequentImageCreativesCreativePreview.name: to.meta.stepNumber = 3; break;
    case bizgainOnboardingRoutes.SubsequentImageCreativesCreativeEdit.name: to.meta.stepNumber = 3; break;
    case bizgainOnboardingRoutes.SubsequentImageCreativesAdPreview.name: to.meta.stepNumber = 3; break;
    case bizgainOnboardingRoutes.SubsequentImageCreativesAdDetailsEdit.name: to.meta.stepNumber = 3; break;

    /* Step No 4 */
    case bizgainOnboardingRoutes.SubsequentGoogleAds.name: to.meta.stepNumber = 4; break;
    case bizgainOnboardingRoutes.SubsequentGoogleAdsEdit.name: to.meta.stepNumber = 4; break;

    /* Step No 5 */
    case bizgainOnboardingRoutes.AgeGenderTarget.name:
      to.meta.isBackButtonDisabled = false;
      to.meta.backButtonRoute = bizgainOnboardingRoutes.SubsequentGoogleAds.name;
      to.meta.stepNumber = 1;
      to.meta.stepCount = 2;
      break;
    case bizgainOnboardingRoutes.LocationTargeting.name:
      to.meta.stepNumber = 2;
      to.meta.stepCount = 2;
      break;

    /* Step No 6 */
    case bizgainOnboardingRoutes.Budget.name:
      to.meta.stepNumber = 1;
      to.meta.stepCount = 2;
      break;
    case bizgainOnboardingRoutes.LinkAccounts.name:
      to.meta.stepNumber = 2;
      to.meta.stepCount = 2;
      break;
  }
}